import ms from './../enums/system.js';
import ct from '../enums/conversionType.js';
import quantityId from '../enums/quantityId.js';
import LeftRightValueFormatter from '../formatters/leftRightValueFormatter.js';

const typesDefault = {
    [ct.ALTITUDE]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "yd",
            [ms.METRIC]: "m",
            [ms.SI]: "m"
        }
    },
    [ct.ANGLE]: {
        quantityId: quantityId.ANGLE,
        set: {
            [ms.CUSTOM]: "deg",
            [ms.HYBRID]: "deg",
            [ms.EUROPEAN]: "deg",
            [ms.IMPERIAL]: "deg",
            [ms.METRIC]: "deg",
            [ms.SI]: "deg"
        }
    },
    [ct.ANGLE_RL]: {
        quantityId: quantityId.ANGLE,
        set: {
            [ms.CUSTOM]: "deg",
            [ms.HYBRID]: "deg",
            [ms.EUROPEAN]: "deg",
            [ms.IMPERIAL]: "deg",
            [ms.METRIC]: "deg",
            [ms.SI]: "deg"
        },
        formatter: new LeftRightValueFormatter("L", "R", "")
    },
    [ct.DISTANCE]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "yd",
            [ms.METRIC]: "m",
            [ms.SI]: "m"
        }
    },
    [ct.DISTANCE_RL]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "yd",
            [ms.METRIC]: "m",
            [ms.SI]: "m"
        },
        formatter: new LeftRightValueFormatter("L", "R", "")
    },
    [ct.HEIGHT]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "ft",
            [ms.METRIC]: "m",
            [ms.SI]: "m"
        }
    },
    [ct.HEIGHT_SHORT]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "cm",
            [ms.HYBRID]: "cm",
            [ms.IMPERIAL]: "ft",
            [ms.METRIC]: "cm",
            [ms.SI]: "m"
        }
    },
    [ct.HEIGHT_SHORT_FTIN]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "cm",
            [ms.HYBRID]: "cm",
            [ms.IMPERIAL]: "ftin",
            [ms.METRIC]: "cm",
            [ms.SI]: "m"
        }
    },
    [ct.DISTANCE_LONG]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "mi",
            [ms.METRIC]: "km",
            [ms.SI]: "m"
        }
    },
    [ct.DISTANCE_LONG_RL]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "mi",
            [ms.METRIC]: "km",
            [ms.SI]: "m"
        },
        formatter: new LeftRightValueFormatter("L", "R", "")
    },
    [ct.TIME]: {
        quantityId: quantityId.TIME,
        set: {
            [ms.CUSTOM]: "s",
            [ms.HYBRID]: "s",
            [ms.EUROPEAN]: "s",
            [ms.IMPERIAL]: "s",
            [ms.METRIC]: "s",
            [ms.SI]: "s"
        }
    },
    [ct.DISTANCE_SHORT]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "ft",
            [ms.METRIC]: "m",
            [ms.SI]: "m"
        }
    },
    [ct.DISTANCE_EXTRA_SHORT]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "cm",
            [ms.HYBRID]: "cm",
            [ms.EUROPEAN]: "cm",
            [ms.IMPERIAL]: "in",
            [ms.METRIC]: "cm",
            [ms.SI]: "m"
        }
    },
    [ct.DISTANCE_SHORT_FTIN]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "cm",
            [ms.HYBRID]: "cm",
            [ms.EUROPEAN]: "cm",
            [ms.IMPERIAL]: "ftin",
            [ms.METRIC]: "cm",
            [ms.SI]: "m"
        }
    },
    [ct.DISTANCE_SHORT_RL]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "ft",
            [ms.METRIC]: "m",
            [ms.SI]: "m"
        },
        formatter: new LeftRightValueFormatter("L", "R", "")
    },
    [ct.DISTANCE_EXTRA_SHORT_RL]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "cm",
            [ms.HYBRID]: "cm",
            [ms.EUROPEAN]: "cm",
            [ms.IMPERIAL]: "in",
            [ms.METRIC]: "cm",
            [ms.SI]: "m"
        },
        formatter: new LeftRightValueFormatter("L", "R", "")
    },
    [ct.DISTANCE_SHORT_FTIN_RL]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "cm",
            [ms.HYBRID]: "cm",
            [ms.IMPERIAL]: "ftin",
            [ms.METRIC]: "cm",
            [ms.SI]: "m"
        },
        formatter: new LeftRightValueFormatter("L", "R", "")
    },
    [ct.SPEED]: {
        quantityId: quantityId.SPEED,
        set: {
            [ms.CUSTOM]: "mps",
            [ms.HYBRID]: "mps",
            [ms.EUROPEAN]: "miph",
            [ms.IMPERIAL]: "miph",
            [ms.METRIC]: "kmh",
            [ms.SI]: "mps"
        }
    },
    [ct.SPIN]: {
        quantityId: quantityId.ROTATION,
        set: {
            [ms.CUSTOM]: "rpm",
            [ms.HYBRID]: "rpm",
            [ms.EUROPEAN]: "rpm",
            [ms.IMPERIAL]: "rpm",
            [ms.METRIC]: "rpm",
            [ms.SI]: "rpm"
        }
    },
    [ct.VELOCITY]: {
        quantityId: quantityId.SPEED,
        set: {
            [ms.CUSTOM]: "mps",
            [ms.HYBRID]: "mps",
            [ms.EUROPEAN]: "miph",
            [ms.IMPERIAL]: "miph",
            [ms.METRIC]: "kmh",
            [ms.SI]: "mps"
        }
    },
    [ct.WIDTH]: {
        quantityId: quantityId.LENGTH,
        set: {
            [ms.CUSTOM]: "m",
            [ms.HYBRID]: "m",
            [ms.EUROPEAN]: "m",
            [ms.IMPERIAL]: "yd",
            [ms.METRIC]: "m",
            [ms.SI]: "m"
        }
    },
    [ct.WEIGHT]: {
        quantityId: quantityId.MASS,
        set: {
            [ms.CUSTOM]: "kg",
            [ms.HYBRID]: "kg",
            [ms.EUROPEAN]: "kg",
            [ms.IMPERIAL]: "lb",
            [ms.METRIC]: "kg",
            [ms.SI]: "kg"
        }
    },
    [ct.NUMBER]: {
        quantityId: quantityId.NUMERIC,
        set: {
            [ms.CUSTOM]: "numeric",
            [ms.HYBRID]: "numeric",
            [ms.EUROPEAN]: "numeric",
            [ms.IMPERIAL]: "numeric",
            [ms.METRIC]: "numeric",
            [ms.SI]: "numeric"
        }
    },
    [ct.PERCENT]: {
        quantityId: quantityId.NUMERIC,
        set: {
            [ms.CUSTOM]: "percent",
            [ms.HYBRID]: "percent",
            [ms.EUROPEAN]: "percent",
            [ms.IMPERIAL]: "percent",
            [ms.METRIC]: "percent",
            [ms.SI]: "percent"
        }
    },
    [ct.PERMILLE]: {
        quantityId: quantityId.NUMERIC,
        set: {
            [ms.CUSTOM]: "permille",
            [ms.HYBRID]: "permille",
            [ms.EUROPEAN]: "permille",
            [ms.IMPERIAL]: "permille",
            [ms.METRIC]: "permille",
            [ms.SI]: "permille"
        }
    },
    [ct.BASISPOINT]: {
        quantityId: quantityId.NUMERIC,
        set: {
            [ms.CUSTOM]: "basispoint",
            [ms.HYBRID]: "basispoint",
            [ms.EUROPEAN]: "basispoint",
            [ms.IMPERIAL]: "basispoint",
            [ms.METRIC]: "basispoint",
            [ms.SI]: "basispoint"
        }
    },
    [ct.TEMPERATURE]: {
        quantityId: quantityId.TEMPERATURE,
        set: {
            [ms.CUSTOM]: "C",
            [ms.HYBRID]: "C",
            [ms.EUROPEAN]: "C",
            [ms.IMPERIAL]: "F",
            [ms.METRIC]: "C",
            [ms.SI]: "K"
        }
    },
    [ct.ACCELERATION]: {
        quantityId: quantityId.ACCELERATION,
        set: {
            [ms.CUSTOM]: "mps2",
            [ms.HYBRID]: "mps2",
            [ms.EUROPEAN]: "mps2",
            [ms.IMPERIAL]: "ftps2",
            [ms.METRIC]: "mps2",
            [ms.SI]: "mps2"
        }
    },
};

export default typesDefault;